module.exports = __webpack_public_path__ + "img/avatar4.9604de6a.png";